// extracted by mini-css-extract-plugin
export default {"p":"styles_p__dvK+n","h":"styles_h__ldN9D"};